import Footer from "../components/Footer";

import OurDepartments from "../components/OurDepartments";
import FeatureSplit from "../components/FeatureSplit";
import TechNavbar from "../components/TechNavbar";
import FadeInSection from "../components/FadeInSection";

const Departments = () => {
  return (
    <div className="h-min-screen">
      {/* <Header /> */}

      <TechNavbar />

      {/* HERO SECTION */}
      <FadeInSection>
        <section className="relative bg-blue-600 pt-16 pb-20 lg:pt-24 lg:pb-32 overflow-hidden">
          {/* Background Decorative Elements (Gradients) */}
          <div className="absolute top-0 left-1/2 w-full -translate-x-1/2 h-full z-0 pointer-events-none">
            <div className="absolute top-0 left-[30%] w-[500px] h-[500px] bg-blue-400/20 rounded-full blur-3xl mix-blend-screen opacity-30"></div>
            <div className="absolute bottom-0 right-[10%] w-[400px] h-[400px] bg-blue-500/20 rounded-full blur-3xl mix-blend-screen opacity-30"></div>
          </div>

          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 z-10">
            <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
              {/* Left Column: Text Content */}
              <div className="text-center lg:text-left">
                <h1 className="text-4xl tracking-tight font-extrabold text-white sm:text-5xl md:text-6xl">
                  <span className="block">Build the future</span>
                  <span className="block text-transparent bg-clip-text text-white mt-2">
                    with cloud-native speed
                  </span>
                </h1>

                <p className="mt-6 text-lg text-white max-w-lg mx-auto lg:mx-0">
                  Deploy scalable applications in seconds. Our infrastructure
                  handles the complexity so you can focus on writing code, not
                  managing servers.
                </p>

                <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                  <a
                    href="#"
                    className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-lg text-blue-600 bg-white  md:py-4 md:text-lg transition-all shadow-lg shadow-blue-500/30"
                  >
                    Start Free Trial
                  </a>
                  <a
                    href="#"
                    className="inline-flex items-center justify-center px-8 py-3 border border-white text-base font-medium rounded-lg text-white hover:bg-blue-600 hover:text-white md:py-4 md:text-lg transition-all"
                  >
                    View Documentation
                  </a>
                </div>

                <div className="mt-8 pt-8 border-t border-white">
                  <p className="text-sm text-white mb-4">
                    Trusted by innovative teams at
                  </p>
                  <div className="flex justify-center lg:justify-start gap-6 grayscale opacity-50">
                    {/* Simple SVG Placeholders for Logos */}
                    <div className="h-8 font-bold text-white text-xl flex items-center">
                      IT PARK UZ
                    </div>
                    <div className="h-8 font-bold text-white text-xl flex items-center">
                      IT PARTK UZ
                    </div>
                    <div className="h-8 font-bold text-white text-xl flex items-center">
                      IT PARK UZ
                    </div>
                    <div className="h-8 font-bold text-white text-xl flex items-center">
                      IT PARK UZ
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column: Hero Image/Illustration */}
              <div className="relative mt-12 lg:mt-0 lg:ml-10">
                <div className="relative mx-auto w-full rounded-lg shadow-2xl lg:max-w-3xl">
                  <div className="relative block w-full bg-gray-800 rounded-lg overflow-hidden aspect-video border border-gray-700 group cursor-pointer">
                    <img
                      className="w-full h-full object-cover opacity-90 transform group-hover:scale-105 transition-transform duration-700"
                      src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
                      alt="Dashboard interface on laptop"
                    />
                    {/* UI Overlay Mockup */}
                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent opacity-60"></div>
                  </div>
                  {/* Floating Card Effect */}
                  {/* <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-lg shadow-xl hidden sm:block">
                                    <div className="flex items-center space-x-3">
                                        <div className="bg-green-100 p-2 rounded-full">
                                            <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" /></svg>
                                        </div>
                                        <div>
                                            <p className="text-sm font-bold text-gray-900">Efficiency Up</p>
                                            <p className="text-xs text-gray-500">+240% this week</p>
                                        </div>
                                    </div>
                                </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </FadeInSection>

      <FadeInSection>
        <section className="bg-white py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
          <div className="max-w-7xl mx-auto">
            {/* Flex Container */}
            <div className="flex flex-col md:flex-row items-center gap-12">
              {/* Left Side: Content (Now First in Code) */}
              <div className="w-full md:w-1/2 text-center md:text-left">
                <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
                  Analyze your data with precision
                </h2>
                <p className="mt-4 text-lg text-gray-500">
                  Gain deep insights into your business performance with our
                  advanced analytics dashboard. Make data-driven decisions
                  faster and optimize your workflow with real-time reporting
                  tools.
                </p>
                <div className="mt-8">
                  <a
                    href="#"
                    className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 md:py-4 md:text-lg transition duration-150 ease-in-out shadow-md hover:shadow-lg"
                  >
                    View Analytics Demo
                    {/* Arrow Icon */}
                    <svg
                      className="ml-2 -mr-1 w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17 8l4 4m0 0l-4 4m4-4H3"
                      />
                    </svg>
                  </a>
                </div>

                {/* Optional: Trust indicators */}
                {/* <div className="mt-6 flex items-center justify-center md:justify-start space-x-2 text-sm text-gray-500">
                                <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                </svg>
                                <span>14-day free trial included</span>
                            </div> */}
              </div>

              {/* Right Side: Image (Now Second in Code) */}
              <div className="w-full md:w-1/2 relative">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                  <img
                    className="w-full h-[400px] object-cover transform hover:scale-105 transition-transform duration-700"
                    src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
                    alt="Analytics dashboard on a laptop screen"
                  />
                </div>
                {/* Optional: Decorative background blob behind image */}
                <div className="absolute -z-10 top-0 -right-10 w-72 h-72 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
                <div className="absolute -z-10 bottom-0 -left-10 w-72 h-72 bg-indigo-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
              </div>
            </div>
          </div>
        </section>
      </FadeInSection>

      {/* COLLABORATE SECTIONO */}
      <FadeInSection>
        <FeatureSplit />
      </FadeInSection>

      {/* FEATUE FOR GROWTH SECTION */}
      <FadeInSection>
        <div class="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
          <div class="mx-auto max-w-lg text-center">
            <h2 class="text-3xl/tight font-bold text-gray-900 sm:text-4xl">
              Features for growth
            </h2>

            <p class="mt-4 text-lg text-pretty text-gray-700">
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Veritatis tenetur, nemo quam voluptas sunt impedit dolorem
              asperiores aliquid doloribus fugit.
            </p>
          </div>

          <div class="mt-8 grid grid-cols-1 gap-8 md:grid-cols-3">
            <div class="rounded-lg border border-gray-200 p-6 cursor-pointer hover:shadow-md">
              <div class="inline-flex rounded-lg bg-gray-100 p-3 text-gray-700">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z"
                  ></path>
                </svg>
              </div>

              <h3 class="mt-4 text-lg font-semibold text-gray-900">
                High performance
              </h3>

              <p class="mt-2 text-pretty text-gray-700">
                Lightning-quick load times optimized for every device
              </p>
            </div>

            <div class="rounded-lg border border-gray-200 p-6 cursor-pointer hover:shadow-md">
              <div class="inline-flex rounded-lg bg-gray-100 p-3 text-gray-700">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                  ></path>
                </svg>
              </div>

              <h3 class="mt-4 text-lg font-semibold text-gray-900">
                Enterprise security
              </h3>

              <p class="mt-2 text-pretty text-gray-700">
                Enterprise-grade security built into every layer
              </p>
            </div>

            <div class="rounded-lg border border-gray-200 p-6 cursor-pointer hover:shadow-md">
              <div class="inline-flex rounded-lg bg-gray-100 p-3 text-gray-700">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 13.5V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 9.75V10.5"
                  ></path>
                </svg>
              </div>

              <h3 class="mt-4 text-lg font-semibold text-gray-900">
                Highly configurable
              </h3>

              <p class="mt-2 text-pretty text-gray-700">
                Adapt every aspect to match your brand and needs
              </p>
            </div>
          </div>
        </div>
      </FadeInSection>

      {/* OUR DEPARTMENTS SECTION */}
      <FadeInSection>
        <OurDepartments />
      </FadeInSection>

      <Footer />
    </div>
  );
};
export default Departments;
